import { render, staticRenderFns } from "./StockScreen4.vue?vue&type=template&id=35a6f5c4"
import script from "./StockScreen4.vue?vue&type=script&lang=js"
export * from "./StockScreen4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports